// Canonical Extra eligibility — UNICA source of truth (frontend).
// Efficacia contrattuale = FIRMA/ACCETTAZIONE CLIENTE (non approvazione interna admin).
// Speculare a backend/helpers/extra_eligibility.py

export const CONTRACT_EFFECTIVE_STATUSES = new Set([
  'firmato_cliente',
  'in_attesa_approvazione',
  'in_validazione',
  'validato',
  'in_attesa_ordine',
  'ordinato',
  'completato',
  // legacy equivalenti ad accettazione cliente
  'accettato_cliente',
  'firmato',
  'signed',
  'final',
  'definitivo',
]);

export const TERMINATED_STATUSES = new Set(['annullato', 'rifiutato', 'rifiutato_dal_cliente']);

const statusOf = (e) => ((e?.approval_status || e?.status || '') + '').toLowerCase();

export const isExtraContractEffective = (e) => {
  if (!e) return false;
  const s = statusOf(e);
  if (TERMINATED_STATUSES.has(s)) return false;
  if (CONTRACT_EFFECTIVE_STATUSES.has(s)) return true;
  if (e.signed_at || e.signed_pdf_url) return true;
  return false;
};

export const isExtraSalEligible = (e) => isExtraContractEffective(e);

export const isExtraFurnitureOperational = (e) =>
  isExtraContractEffective(e) && e?.extra_type === 'fornitura';

export const isExtraWorksOperational = (e) =>
  isExtraContractEffective(e) && (e?.extra_type || 'lavoro') !== 'fornitura';
